const INITIAL_STATE = {
    chats: [],
    activeChat: null,
    messages: [],
    loadingChats: false,
    loadingHistory: false,
    sendingMessage: false
};

const WhatsAppReducers = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'WHATSAPP_CHATS_LOADING':
            return {
                ...state,
                loadingChats: true
            };
        case 'WHATSAPP_CHATS_SUCCESS':
            return {
                ...state,
                chats: action.chats,
                loadingChats: false
            };
        case 'WHATSAPP_CHATS_ERROR':
            return {
                ...state,
                loadingChats: false
            };
        case 'WHATSAPP_HISTORY_LOADING':
            return {
                ...state,
                loadingHistory: action.showLoading ? true : state.loadingHistory
            };
        case 'WHATSAPP_HISTORY_SUCCESS':
            return {
                ...state,
                messages: action.messages,
                loadingHistory: false
            };
        case 'WHATSAPP_HISTORY_ERROR':
            return {
                ...state,
                loadingHistory: false
            };
        case 'WHATSAPP_SELECT_CHAT':
            return {
                ...state,
                activeChat: action.chat,
                messages: []
            };
        case 'WHATSAPP_SEND_MESSAGE_START':
            return {
                ...state,
                sendingMessage: true
            };
        case 'WHATSAPP_SEND_MESSAGE_SUCCESS':
            return {
                ...state,
                messages: [action.message, ...state.messages],
                sendingMessage: false
            };
        case 'WHATSAPP_SEND_MESSAGE_ERROR':
            return {
                ...state,
                sendingMessage: false
            };
        case 'WHATSAPP_UPDATE_CHATS':
            return {
                ...state,
                chats: action.chats
            };
        default:
            return state;
    }
};

export default WhatsAppReducers;
